import {Component} from '@angular/core';
/**
 * \@title Configurable progress-bar
 */
export class ProgressBarConfigurableExample {
  color = 'primary';
  mode = 'determinate';
  value = 50;
  bufferValue = 75;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'progress-bar-configurable-example',
  templateUrl: 'progress-bar-configurable-example.html',
  styleUrls: ['progress-bar-configurable-example.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ProgressBarConfigurableExample_tsickle_Closure_declarations() {
/** @type {?} */
ProgressBarConfigurableExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ProgressBarConfigurableExample.ctorParameters;
/** @type {?} */
ProgressBarConfigurableExample.prototype.color;
/** @type {?} */
ProgressBarConfigurableExample.prototype.mode;
/** @type {?} */
ProgressBarConfigurableExample.prototype.value;
/** @type {?} */
ProgressBarConfigurableExample.prototype.bufferValue;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
